import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { validateCategoryForm } from '../../../utils/validation';
import CommonLoader from '../../loaderComponent/CommonLoader';
import CommonToast from '../../Toaster/CommonToast';

export default class AddNewCategory extends Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      status: '',
      loading: false,
      hasError: false,
      errMsg: "",
      completed: false,
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    }
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  handleBack = () => {
    // this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/expense-category-list");
      this.setState({ loading: false });
    }, 200);
  }

  onSubmit = async (e) => {

    this.setState({ loading: true })
    e.preventDefault();
    const errors = validateCategoryForm(
      this.state.name,
      this.state.status
    );
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const categoryData = {
      name: this.state.name,
      status: this.state.status,
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      console.log(categoryData);
      await axios.post('/expenseCategory/create', categoryData, { headers });
      this.setState({
        completed: true,
        toastMessage: "Category created successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/expense-category-list");
      }, 900);
    } catch (error) {
      if (error.response) {
        console.error('Error response from server:', error.response.data.error);
        this.setState({
          completed: true,
          toastMessage: error.response.data.error,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      } else {
        console.error('Error creating expense header:', error.message);
        this.setState({ hasError: true, errMsg: "An unexpected error occurred." });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      }
    }

  };

  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}

        />
        <CommonLoader isLoading={this.state.loading}>
          <>
            <Card className="mb-3">
              <Card.Header className="text-white"><strong>Add Expense Category</strong></Card.Header>
              <Card.Body>
                {this.state.loading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="outline-primary" className="loader" />
                  </div>
                ) : (
                  <Form onSubmit={this.onSubmit}>
                    <Row className="mb-3">
                      <Col xs={12} md={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Category Name</Form.Label>
                          <Form.Control type="text" name="name" size="md" value={this.state.name} onChange={this.handleChange}
                            placeholder='Enter category name'
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Status</Form.Label>
                          <Form.Control as="select" className="form-select" name="status" value={this.state.status} onChange={this.handleChange} >
                            <option value="" disabled>Select Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.status && <small className="text-danger">{this.state.errors.status}</small>}
                        </span>
                      </Col>
                    </Row>
                    <div className='add-cancel-btn '>
                      <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                        Add
                      </Button>
                      <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </>
        </CommonLoader >
      </div >
    )
  }
}
